var scriptTag,
	firstScriptTag = document.getElementsByTagName('script')[0];
if (!document.getElementById('piniterest-js')) {
	scriptTag = document.createElement('script');
	scriptTag.id = 'piniterest-js';
	scriptTag.async = 1;
	scriptTag.src = 'https://assets.pinterest.com/js/pinit.js';
	firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
}
module.exports = {};
